import React, { createContext, useState } from 'react';
import { useSelector } from 'react-redux';
import { initialFilterState } from './constants';
import { AppState } from '../../reducers';
import { IFilterState } from './types';
import { ProductCondition } from '../../types';

const initialContextValue: IPriceListFilterContext = {
  filters: initialFilterState,
  selectedLegacyVariants: null,
  selectedSizeVariants: null,
  selectedCondition: null,
  setFilters: () => undefined,
  reload: () => undefined,
};

export const PriceListFilterContext = createContext<IPriceListFilterContext>(
  initialContextValue
);

export const PriceListFilterContextContainer: React.FC<React.PropsWithChildren<
  React.PropsWithChildren<unknown>
>> = props => {
  const [filters, setFilters] = useState<IFilterState>(initialFilterState);
  const selectedLegacyVariants = useSelector(
    (state: AppState) => state.areas.product.variants
  );
  const selectedSizeVariants = useSelector(
    (state: AppState) => state.areas.product.variantSizes
  );
  const selectedCondition = useSelector(
    (state: AppState) => state.areas.product.condition
  );

  const reload = (
    newFilters: IFilterState,
    routeDispatch: (action: any) => void,
    resetToDefaults?: boolean
  ) => {
    setFilters(newFilters);
    routeDispatch({
      type: 'PRICE_FILTER',
      options: {
        ...newFilters,
      },
      variants: resetToDefaults === true ? null : selectedLegacyVariants,
      variantSizes: resetToDefaults === true ? null : selectedSizeVariants,
      condition: resetToDefaults === true ? 'new' : selectedCondition,
    });
  };

  return (
    <PriceListFilterContext.Provider
      value={{
        filters,
        setFilters,
        selectedLegacyVariants,
        selectedSizeVariants,
        selectedCondition,
        reload,
      }}
    >
      {props.children}
    </PriceListFilterContext.Provider>
  );
};

interface IPriceListFilterContext {
  filters: IFilterState;
  selectedLegacyVariants: number[] | null;
  selectedSizeVariants: string[] | null;
  selectedCondition: ProductCondition | null;
  setFilters: React.Dispatch<React.SetStateAction<IFilterState>>;
  reload: (
    newFilters: IFilterState,
    routeDispatch: (action: any) => void,
    resetToDefaults?: boolean
  ) => void;
}
